import React from "react";
import { Box, Link, Typography } from "@mui/material";

const currentYear = new Date().getFullYear();

export const CreatedBy = () => {

	return (
		<Box sx={{
			left: 0,
			bottom: 0,
			display: "flex",
			alignItems: "center",
			margin: "1em 0 0 0.5em"
		}}>
			<Typography
				fontSize="0.7rem"
				color="secondary.lighter"
				marginBottom="0.2rem"
				marginRight="0.3rem"
			>
				Created by{" "}
				<Link
					href="https://www.reddit.com/user/u12mam9/"
					target="_blank"
					rel="noopener noreferrer"
					underline="hover"
					color="inherit"
					sx={{ fontWeight: "bold", textDecoration: "underline" }}
				>
					u12mam9
				</Link>
			</Typography>
		</Box>
	);
};
